.form {
  display: var(--haus-authentication__form__display, flex);
  flex-direction: var(--haus-authentication__form__flex-direction, column);
  gap: var(--haus-authentication__form__gap, var(--haus-spacing-md, 16px));
  width: var(--haus-authentication__form__width, 100%);
}

.inputGroup {
  display: var(--haus-authentication__inputgroup__display, flex);
  flex-direction: var(--haus-authentication__inputgroup__flex-direction, column);
}

.label {
  margin-bottom: var(--haus-authentication__label__margin-bottom,
      var(--haus-spacing-xs, 4px)) !important;
}

.errorMessage {
  padding: var(--haus-authentication__error-message__padding, var(--haus-spacing-sm, 8px));
  border-radius: var(--haus-authentication__error-message__border-radius, 4px);
  font-family: var(--haus-authentication__error-message__font-family,
      var(--haus-typography-body-font-family, 'Inter, sans-serif'));
  font-size: var(--haus-authentication__error-message__font-size,
      var(--haus-typography-body-font-size, 14px));
  font-weight: var(--haus-authentication__error-message__font-weight, 400);
  line-height: var(--haus-authentication__error-message__line-height,
      var(--haus-typography-body-line-height, 1.4));
  letter-spacing: var(--haus-authentication__error-message__letter-spacing,
      var(--haus-typography-body-letter-spacing, -0.26px));
  text-align: var(--haus-authentication__error-message__text-align, center);
  background-color: var(--haus-authentication__error-message__background-color, #ffd9d9);
  color: var(--haus-authentication__error-message__color, #972626);
  border: var(--haus-authentication__error-message__border, 1px solid #ffd9d9);
}

.successMessage {
  padding: var(--haus-authentication__success-message__padding, var(--haus-spacing-sm, 8px));
  border-radius: var(--haus-authentication__success-message__border-radius, 4px);
  font-family: var(--haus-authentication__success-message__font-family,
      var(--haus-typography-body-font-family, 'Inter, sans-serif'));
  font-size: var(--haus-authentication__success-message__font-size,
      var(--haus-typography-body-font-size, 14px));
  font-weight: var(--haus-authentication__success-message__font-weight, 400);
  line-height: var(--haus-authentication__success-message__line-height,
      var(--haus-typography-body-line-height, 1.4));
  letter-spacing: var(--haus-authentication__success-message__letter-spacing,
      var(--haus-typography-body-letter-spacing, -0.26px));
  text-align: var(--haus-authentication__success-message__text-align, center);
  background-color: var(--haus-authentication__success-message__background-color, #d9ffe6);
  color: var(--haus-authentication__success-message__color, #1b5e20);
  border: var(--haus-authentication__success-message__border, 1px solid #d9ffe6);
}

.loginActions {
  display: var(--haus-authentication__login-actions__display, flex);
  flex-direction: var(--haus-authentication__login-actions__flex-direction, row);
  align-items: var(--haus-authentication__login-actions__align-items, center);
  justify-content: var(--haus-authentication__login-actions__justify-content, space-between);
  gap: var(--haus-authentication__login-actions__gap, var(--haus-spacing-sm, 8px));
  flex-wrap: var(--haus-authentication__login-actions__flex-wrap, wrap);
}

.requestResetButtons {
  display: var(--haus-authentication__request-reset-buttons__display, flex);
  flex-direction: var(--haus-authentication__request-reset-buttons__flex-direction, row);
  align-items: var(--haus-authentication__request-reset-buttons__align-items, center);
  gap: var(--haus-authentication__request-reset-buttons__gap,
      var(--haus-spacing-sm, 8px));
  flex-wrap: var(--haus-authentication__request-reset-buttons__flex-wrap, wrap);
}